/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Home',
	myContent: 'Contenuto personale',
	teamContent: 'Contenuto team',
	folder: 'Cartella',
	files: 'File',
	actionMenu: 'Menu Azione ',
	myFolder: 'Cartelle personali',

	emptyFolderNoContent: 'Nessun contenuto',

	//EmptyStates
	emptyRecentTitle: 'Di recente l\'utente non ha visualizzato alcun contenuto.',
	emptyStateTitle: 'Inizia aggiungendo i dati',
	emptyStateBody: 'Fare clic su Carica dati o trascinare e rilasciare per caricare i dati.',
	emptySearchResultTitle: 'La ricerca non ha restituito alcun risultato.',
	emptyPortalTitle: 'Nessun portale',
	emptyPortalBody: 'Attualmente non si dispone di alcun portale.',
	emptyWsProjectTitle: 'Creare innanzitutto un blocco note in Watson Studio.',
	emptyWsProjectBody: 'Quando si ritorna in Cognos Analytics, il blocco note verrà visualizzato in questo punto.',
	emptyFilteredResultTitle: 'I filtri applicati non hanno restituito alcun risultato.',
	emptyDialogViewTitle: 'Nessun elemento ',
	removeFromRecents: 'Rimuovi dai recenti',

	// Welcome Banner
	welcomeBannerGreeting: 'Benvenuti in Cognos Analytics.',
	welcomeBannerDescription: 'Cognos Analytics autorizza gli utenti ad analisi autonome basate su AI. Esaminare in che modo la preparazione dei dati, il rilevamento e le visualizzazioni dei dati possono condurre a decisioni più attendibili.',
	welcomeBannerDescription_trialUser: 'Si può iniziare proprio adesso dando uno sguardo al video introduttivo, alla presentazione del prodotto e alla scheda Introduzione.',
	takeTourButtonLabel: 'Osserva la presentazione del prodotto',
	watchVideoButtonLabel: 'Guarda il video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Si è sicuri di voler disattivare il banner di benvenuto dalla pagina iniziale? È possibile in qualsiasi momento riattivare il banner in Profilo e le impostazioni in > Impostazioni > Generale. ',
	hideWelcomeBannerTitle: 'Disattiva il banner di benvenuto',
	ok: 'OK',
	cancel: 'Annulla',
	//howto video dialog
	modal_how_title: 'Come fare i video',
	modal_overview_title: 'Osserva la panoramica su Cognos Analytics',
	modal_how_play: 'Riproduci video',
	modal_how_video_title_overview: 'Panoramica',
	modal_how_video_title_getStarted: 'Introduzione alla versione 11.2',
	modal_how_video_title_newUI: 'Benvenuti nella nuova esperienza Cognos ',
	modal_how_video_title_dataModule: 'Panoramica sui moduli dati ',
	modal_how_video_title_explore: 'Panoramica sull\'esplorazione dei dati ',
	modal_how_video_title_dashboard: 'Panoramica sui dashboard interattivi ',
	modal_how_video_title_reporting: 'Panoramica sulla creazione di report ',
	modal_how_video_title_mobile: 'La potenza di Cognos nel palmo della mano ',

	// Toolbar
	search: 'Ricerca',
	addFolder: 'Aggiungi cartella ',
	addLink: 'Aggiungi collegamento ',
	filter: 'Filtro',
	sort: 'Ordinamento',
	settings: 'Impostazioni',
	tilesView: 'Vista riquadri ',
	listView: 'Vista elenco',
	columnView: 'Vista colonna ',

	// Toolbar Actions
	sortBy: 'Ordina per',
	sortOrder: 'Ordina',
	name: 'Nome',
	modifiedTime: 'Modificato',
	type: 'Tipo',
	ascending: 'Crescente',
	descending: 'Discendente',

	filterType: 'Tipo',
	filterModificationTime: 'Modificato',
	all: 'Tutte',
	today: 'Oggi',
	yesterday: 'Ieri',
	pastWeek: 'Settimana scorso',
	pastMonth: 'Mese scorso',
	resetFilters: 'Reimposta filtri',

	filterSearchPlaceHolder: 'Filtra per parola chiave',

	resetFilterTag: 'Fare clic su X per ripristinare i filtri.',
	filterTagToolTip: 'Filtri applicati: %{appliedFilters}.',

	folderName: 'Nome cartella',
	addAFolder: 'Aggiungi una cartella',
	add: 'Aggiungi',
	error: 'Errore',
	newFolderDefaultName: 'Nuova cartella',
	toastCreateNewFolder: 'La cartella %{nameOfFolder} è stata creata in %{tabName}.',
	folderAdded: 'Cartella aggiunta',
	refresh: 'Aggiorna',
	openFolder: 'Apri cartella ',

	addAUrl: 'Aggiungi un URL',
	linkName: 'Nome URL',
	linkNamePlaceholder: 'Aggiungi un nome URL',
	linkDescription: 'Descrizione (facoltativo)',
	linkDescriptionPlaceholder: 'Aggiungi una descrizione',
	linkUri: 'URL',
	linkUriPlaceholder: 'Aggiungi un URL con un dominio accettabile',
	acceptableDomains: 'Domini accettabili',
	viewAcceptableDomains: 'Visualizza i domini accettabili',
	mandatoryField: 'Campo obbligatorio',
	linkAdded: 'URL aggiunto',
	toastCreateNewLink: '%{nameOfLink} è stato aggiunto a %{tabName}.',
	noEntries: 'Non sono presenti voci nell\'elenco di domini accettabili. Contattare l\'amministratore.',

	compact: 'Compatto',
	short: 'Breve',
	default: 'Impostazione predefinita',
	rowSize: 'Dimensione riga ',

	// GroupyByTypes
	folders: 'Cartelle',
	reports: 'Report',
	dashboards: 'Dashboard',
	data: 'Dati',
	packages: 'Package',
	explorations: 'Esplorazioni',
	stories: 'Storie',
	notebooks: 'Blocco note',
	others: 'Altro',

	// Error Messages
	itemsOverLimit: 'Il nome specificato "%{itemName}" ha superato il limite massimo (20). Specificare un differente nome per continuare.',
	errorMessageLengthFolderName: 'Immettere un nome di cartella di lunghezza inferiore a 255 caratteri.',
	errorMessageLengthLinkName: 'Immettere un nome link che non superi 255 caratteri.',
	toastLaunchPerspectiveError: 'Impossibile aprire %{objectType}.',
	errorNoAccessTitle: 'Non si dispone dell\'accesso a questo contenuto.',
	errorNoAccessBody: 'Contattare l\'amministratore o fare riferimento al seguente collegamento:',
	errorEnableExternalContent: 'Abilitazione del contenuto esterno',

	//TableHeader
	lastModified: 'Ultima modifica',
	location: 'Ubicazione',
	tenant: 'Locatario',

	// GetStartedTab
	getStartedLabel: 'Attivazione ed esecuzione in IBM Cognos Analytics',
	learningHowToLabel: 'Risorse didattiche',
	learningHowToDescription: 'Ampliare le proprie conoscenze e ottenere supporto contattando la community, leggendo la documentazione e osservando i video.',
	learningHowToActionLabel: 'Avviare il riquadro di apprendimento',
	howToVideosLabel: 'Video Come fare',
	howToVideosDescription: 'Imparare in che modo utilizzare IBM Cognos Analytics e iniziare a ottenere informazioni dettagliate sui dati.',
	howToVideosActionLabel: 'Osserva i video',
	acceleratorCatalogLabel: 'Catalogo acceleratori',
	acceleratorCatalogDescription: 'Sfogliare un catalogo sempre più ampio degli utilizzi industriali, delle migliori guide pratiche, visualizzazioni personalizzate e molto altro.',
	acceleratorCatalogActionLabel: 'Sfoglia catalogo',
	sampleSectionTitle: 'Esempi',
	sampleSectionDescription: 'Provare con l\'ausilio di esempi che mostrano tutto ciò che Cognos Analytics offre.',
	// Samples Section
	createDashboardSampleTitle: 'Come creare il primo dashboard',
	createDashboardSampleDescription: 'Iniziare ad utilizzare Analytics con i dashboard Cognos.',
	covid19SampleTitle: 'Dashboard COVID',
	covid19SampleDescription: 'Esplorare l\'arte del possibile con questo dashboard Cognos analizzando i dati correlati a COVID-19 e le estensioni personalizzate.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Estendere la libreria di visualizzazione con visualizzazioni personalizzate come grafici Sankey.',
	viewAllSamplesActionLabel: 'Visualizzare tutti gli esempi',
	byFeatureTitle: 'In base alla funzione ',
	byFeatureDescription: 'Sfoglia gli esempi in base alla funzione, come, ad esempio, funzionalità principale, controlli personalizzati, estensioni, notebook e date relative. ',
	byIndustryTitle: 'In base al settore',
	byIndustryDescription: 'Sfoglia gli esempi in base al settore, come, ad esempio, automobilistico, bancario e altro ancora. ',
	// SamplesTab
	sampleTabTitle: 'Lasciati ispirare dai nostri campioni predefiniti',
	sampleTabLabel: 'Visita il Catalogo acceleratori per ulteriori campioni e estensioni di IBM, partner e clienti',

	// quickLaunch
	quickLaunchLabel: 'Avvio rapido',
	expand: 'Espandi',
	collapse: 'Comprimi',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Iniziare scegliendo cosa si desidera creare.',

	// contentPageView
	contentPageTitleLabel: 'Contenuto',
	uploadFile: 'Carica dati',
	new: 'Nuovo',
	create: 'Crea',
	more: 'Altro',

	// open dialog
	selectDataSourcesToAdd: 'Selezionare l\'origine dati da aggiungere.',
	openDialogDefaultTitle: 'Apri',

	// save dialog
	save: 'Salva',
	saveAs: 'Salva con nome',
	saving: 'Salvataggio in corso...',
	selectedDestination: 'Destinazione selezionata: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' già esiste con un tipo differente. Selezionare un nome differente.',
	confirmOverwriteTitle: 'Conferma la sostituzione dei dati esistenti',
	confirmOverwriteMsg: 'Il file \'%{nameOfFile}\' già esiste. Si desidera sostituire i dati con i dati contenuti nel file selezionato?',

	// copy move dialog
	copy: 'Copia',
	move: 'Sposta',
	copyOrMove: 'Copia o sposta: ',
	copyOnly: 'Copia ',
	createShortcut: 'Crea collegamento',
	createShortcutDialogTitle: 'Crea collegamento: ',

	// External asset types
	wsProject: 'Progetto Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Package',
	dataModule: 'Modulo dati',
	exploration: 'Esplorazione',
	mode: 'Modalità',
	live: 'Dinamico',
	snapshot: 'Snapshot',
	noSnapshotsFound: 'Nessuna Snapshot trovata',
	uploadedFile: 'File caricato',
	fileUpload: 'Carica dati',
	dataSetEx: 'Dataset',
	externalRepository: 'Repository esterno',
	queryMode: 'Modalità di query',
	queryModeCompatible: 'Compatibile',
	queryModeDynamic: 'Dinamica',
	report: 'Report',
	activeReport: 'Report attivo',
	query: 'Query',
	analysis: 'Analisi',
	dashboard: 'Dashboard',
	dashboardTemplate: 'Modello di dashboard',
	jupyterNotebook: 'Blocco note',
	wsNotebook: 'Notebook Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Storia',
	workspace: 'Spazio di lavoro',
	pagelet: 'Pagina',
	content: 'Contenuto',
	directory: 'Spazi dei nomi',
	dataSet: 'Dataset',
	powerPlayCube: 'Cubo PowerPlay',
	powerPlayReport: 'Report PowerPlay',
	powerPlay8Report: 'Report PowerPlay',
	powerPlay8ReportView: 'Vista report PowerPlay',
	reportTemplate: 'Modello di report',
	packageConfigurations: 'Configurazione del package',
	agent: 'Agent',
	agentDefinition: 'Definizione agent',
	agentDefinitionView: 'Vista Agent',
	dataMovementTask: 'Attività di spostamento dati',
	dataMovementTaskAlias: 'Alias attività di spostamento dati',
	document: 'Documento',
	DocumentRetention: 'Proprietà documento',
	jobDefinition: 'Definizione processo',
	job: 'Processo',
	metricsDataSourceETLTask: 'Attività ETL origine dati metriche',
	metricsExportTask: 'Attività di esportazione metriche',
	metricsFileImportTask: 'Attività di importazione file delle metriche',
	metricsMaintenanceTask: 'Attività di manutenzione metriche',
	planningTask: 'Attività di pianificazione',
	shortcut: 'Collegamento',
	URL: 'URL',
	launchable: 'Avviabile',
	dataSetFolder: 'Cartella dataset',
	ViewAccessibleLabel: 'Visualizzare %{label}',
	overrideReportOptions: 'Ignora opzioni del report predefinite',
	formats: 'Formati',
	saveReport: 'Salva il report',
	promptForValues: 'Richiedi',
	reportView: 'Vista report',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Dati Excel',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Dettagli',
	open: 'Apri',
	created: 'Creato',
	modified: 'Modificato',
	owner: 'Proprietario',
	dataSource: 'Origine dati',
	share: 'Condividi',
	addToFavorites: 'Aggiungi a preferiti',
	properties: 'Proprietà',
	detailsEmptyStateBody: 'Selezionare un elemento per visualizzarne i dettagli',
	editNameAndDescription: 'Modifica nome e descrizione',
	none: 'Nessuna',

	//rename dialog
	nameInvalid: 'Il nome non è valido',
	namePlaceholder: 'Immetti un nome',
	description: 'Descrizione',
	descriptionInvalid: 'La descrizione non può superare i 350 caratteri.',
	descriptionPlaceholder: 'Immettere una descrizione',
	errorMessageApostropheError: 'Immettere un nome file che non contenga entrambi i caratteri  \' e ".',
	renameCollisionError: '%{name} esiste già. Scegliere un nome differente.',
	unknownRenameError: 'Ridenominazione elemento non riuscita. Contattare l\'amministratore per ulteriore assistenza.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Impossibile aprire la cartella specificata.',

	//Upload
	uploadToFolder: "Caricare in <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Caricare in <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> e avviare %{launchAction}",
	quickUpload: "Caricamento rapido",
	quickUploadAndLaunch: "Trascinare e rilasciare i file da caricare in <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> e aprirli in uno dei seguenti spazi.",
	unsupportedFilesSingle: "%{files} non è stato caricato perché non è valido per l'avvio rapido.",
	unsupportedFilesMultiple: "I file non sono stati caricati perché tutti i file selezionati devono essere validi per utilizzare Avvio rapido.",
	unsupportedFilesSingleInvalid: "%{files} non è valido.",
	unsupportedFilesMultipleInvalid: "%{files} non sono validi.",
	supportedFileTypes: "Sono consentiti solo i seguenti tipi di file: %{extensions}.",
	uploadDragAndDrop: "Trascina e rilascia",
	uploadDragAndDropMessage: "Trascinare e rilasciare il file qui per caricarlo in <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'I criteri di ricerca \'%{searchTerm}\' sono stati salvati.',
	searchWasntSaved: 'I criteri di ricerca \'%{searchTerm}\' non sono stati salvati.',
	searchSuggestions: 'Suggestioni',
	savedSearch: 'Ricerche salvate',
	searchWasDeleted: 'I criteri di ricerca \'%{searchTerm}\' sono stati eliminati.',
	searchWasntDeleted: 'I criteri di ricerca \'%{searchTerm}\' non sono stati eliminati.',
	savedBarTitle: 'Cerca in Cognos Analytics',
	searchContentPageTitle: 'Ricerca',
	searchContentPageTitleLabel: 'Visualizzazione dei risultati per \'%{searchTerm}\'',
	showingSearchRsult: 'Visualizzazione degli elementi %{resultCount}',
	saveSearch: 'Salva ricerca',
	saveTenSearches: 'È possibile salvare 10 ricerche.',
	deleteASearch: 'Eliminarne una per salvarne un\'altra.',
	close: 'Chiudi',

	//recent view
	recents: 'Recente',
	noAccessRecent: 'Nessun accesso',
	noAccessRecentMsg: 'Non si dispone dell\'accesso a questo asset. Potrebbe essere stato disabilitato o eliminato o le autorizzazioni potrebbero essere state ridotte. Verificare lo stato dell\'asset nell\'ubicazione origine prevista. È possibile rimuovere l\'asset dagli elementi recenti facendo clic su OK.',
	noAccessMsg: 'Non si dispone dell\'accesso a questo asset. Potrebbe essere stato disabilitato o eliminato o le autorizzazioni potrebbero essere state ridotte.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} elementi selezionati',
	itemSelected: '%{nameOfSelection} elemento selezionato'

});